/**
 * Initializes the AIMI Image Library functionality.
 *
 * @param {Object} aimi_image_library - The AIMI Image Library namespace.
 * @param {jQuery} $ - The jQuery library.
 * @param {Object} app - The application object.
 * @param {*} undefined - An undefined value.
 */

(function (aimi_image_library, $, app, undefined) {
  const menus = {
    'Image Collections': {'icon': 'fa-images', 'index': 1},
    'Image Tags': {'icon': 'fa-tags', 'index': 2},
    'Uploads': {'icon': 'fa-upload', 'index': 3}
  };


  // Private object
  let __this = {};
  __this.collections = {'list': [], 'selected': []};
  __this.images = {'list': [], 'selected': []};
  __this.defaultConfig = {images: {}, collections: {}, tags : {}, menus: menus, activeMenuIndex: 1, collectionsContainerClass: '', 'imagesContainerClass': ''};
  __this.globalConfig = {};

  /**
   * Defines a class responsible for handling a collection of images.
   * This class extends the functionality of TableList to provide a specialized interface
   * for managing, displaying, and interacting with image collections.
   */
  class ImageCollections extends TableList {

    /**
     * Creates an instance of ImageCollections.
     */
    constructor(app, containerPlaceHolder, listRow, searchInputId, collection = null) {
      let [collectionsContainer, container] = ImageCollections.createContainer(app, containerPlaceHolder);
      super(app, container, listRow, searchInputId)
      this.containerPlaceHolder = containerPlaceHolder;
      this.paginator = new Paginator(30);
      this.currentCollection = collection;
      this.renderList = this.renderList.bind(this);
      this.lazyloader = new LazyLoader(app, container, this.renderList);
      this.container = container;
      this.container.empty();
      this.container.empty();
      this.collectionsContainer = collectionsContainer;
      this.onClick();
    }

    static createContainer(app, containerPlaceHolder) {
      let $container = null;
      let $containerCollections = containerPlaceHolder.find('[data-image-collections]');
      if ($containerCollections.length === 0) {
        const page = _.template(app.templates['image_library__collections']);
        $container = $(page());
        $container.appendTo(containerPlaceHolder);
        $containerCollections = $container.find('[data-image-collections]');
        $containerCollections.addClass(__this.globalConfig.collectionsContainerClass);
      }
      Responsive.getCollectionsColumn(containerPlaceHolder, $containerCollections);
      return [$container, $containerCollections];
    }

    /**
     * Gets the scrollable area for the container.
     * @returns {jQuery} The jQuery element representing the scrollable area.
     */
    getScrollableArea() {
      return this.container.closest('.nicescroll-bar');
    }

    static prepareCard(row, page, checked) {
      let data = {
        ...{'checked': checked},
        ...{
          'disabled': true,
          'available': Math.floor(Math.random() * Math.floor(40)),
          'total': row.images,
          'countText': 'images'
        }
      };

      if (!app.isEmpty(__this.globalConfig.collections)) {
        data = {...data, ...__this.globalConfig.collections};
      }

      data = {...data, ...row};

      if(data.removeButton) {
        // console.log(data);
      }
      const $page = $(page(data));
      return $page;
    }

    /**
     * Prepares a row for rendering.
     * @param {Object} row - The row data.
     * @returns {jQuery} The jQuery element representing the prepared row.
     */
    prepareRow(row) {
      let selected = [];
      if (!app.isEmpty(this.currentCollection)) {
        selected = [this.currentCollection.id.toString()];
      }
      const checked = _.contains(selected, row.id.toString());

      const page = _.template(this.app.templates[this.listRow]);
      const $page = ImageCollections.prepareCard(row, page, checked);

      let $images = $('[data-type="image"]', $page);
      $images.each(function (index, image) {
        if ($(image).attr('data-src') !== '') {
          app.observerManager.observeIntersection(image);
        }
      });

      return $page;
    }

    loaderData = {
      id: null,
      disabled: '',
      checked: false,
      thumbnail: '',
      name: this.staticPH,
      images: this.staticPH,
      countText: this.staticPH
    };

    async loadTillCollection(collection) {
      if (!app.isEmpty(collection) && (collection.id < this.lastLoaded.id)) {
        this.container.empty();
        this.currentCollection = collection;
        this.paginator.currentPage = null;
        return this.renderList();
      }
      return true;
    }

    /**
     * Renders the list of image collections.
     * @returns {Promise} A promise that resolves when the list is rendered.
     */
    async renderList() {
      this.isRendering = true;
      const $listContainer = this.container;
      this.showLoader(this.loaderData, 30);
      let collections = [];

      if (app.isEmpty(__this.collections.list)) {
        const response = await this.app.apis['image-collections'].get();
        __this.collections.list = response.result;
        window['imageCollections'] = _.indexBy(__this.collections.list, 'id');
      }

      if (this.paginator.currentPage === null) {
        this.paginator.setData(__this.collections.list);
        this.paginator.setCurrentPage(1);

        if (this.currentCollection) {
          collections = this.paginator.loadDataUntilIdFound(this.currentCollection.id);
        } else {
          collections = this.paginator.getCurrentPage();
        }
      } else {
        collections = this.paginator.getNextPage();
      }

      // Find the item with the minimum id
      const minId = collections.reduce((minItem, item) => !minItem || item.id < minItem.id ? item : minItem, null);

      if (!app.isEmpty(minId)) {
        this.lastLoaded = minId;
      }

      this.removeLoader();

      if (collections.length) {
        _.each(collections, (row) => {
          let $row = this.prepareRow(row);
          $row.appendTo($listContainer);
        });
      }

      app.initSimpleBar(this.getScrollableArea()[0]);
      this.isRendering = false;

      if(!app.isEmpty(__this.globalConfig.viewCollection)) {
        this.container.find(`[data-image-collection=${__this.globalConfig.viewCollection}]`).trigger('click');
        return false;
      }

      return this.paginator.hasMoreData();
    }

    onClick() {
      const self = this;
      this.container.off('click.data-image-collection').on('click.data-image-collection', '[data-image-collection]', function () {
        if (self.collectionsContainer) {
          self.collectionsContainer.hide();
        }
        const $button = $(this);
        let collectionId = $(this).data('image-collection');
        app.button($button, 'loading');
        imageInputAction(null, 'reset-image-selection');
        const imagesManager = new Images({'collectionId': collectionId}, app, self.containerPlaceHolder, 'image_library__image-card', false);
        imagesManager.onRenderList().then(function () {
          const $cards = $(`.infinite-collection-item`);
          const $collectionCard = $(`.infinite-collection-item[data-id=${collectionId}]`);
          if ($collectionCard.length) {
            $cards.find('input').prop('checked', false);
            $collectionCard.find('input').prop('checked', true);
          }
          app.button($button, 'reset');
        })

      });
    }
  }

  window["ImageCollections"] = ImageCollections;

  class ImageTags extends TableList {
    constructor(app, containerPlaceHolder, listRow, searchInputId, tag = null) {
      let [tagsContainer, container] = ImageTags.createContainer(app, containerPlaceHolder);
      super(app, container, listRow, searchInputId)
      this.containerPlaceHolder = containerPlaceHolder;
      this.paginator = new Paginator(30);
      this.currentTag = tag;
      this.renderList = this.renderList.bind(this);
      this.lazyloader = new LazyLoader(app, container, this.renderList);
      this.container = container;
      this.container.empty();
      this.tagsContainer = tagsContainer;
      this.onClick();
      if(!app.isEmpty(__this.globalConfig.viewTag)) {
        const $button = this.container.find(`[data-tag-action="view-images"][data-image-tag=${__this.globalConfig.viewTag}]`);
        this.getImages(__this.globalConfig.viewTag, $button);
      }
    }

    static createContainer(app, containerPlaceHolder) {
      let $container = null;
      let $containerCollections = containerPlaceHolder.find('[data-image-tags]');
      if ($containerCollections.length === 0) {
        const page = _.template(app.templates['image_library__image-tags']);
        $container = $(page());
        $container.appendTo(containerPlaceHolder);
        $containerCollections = $container.find('[data-image-tags]');
      }
      return [$container, $containerCollections];
    }

    /**
     * Gets the scrollable area for the container.
     * @returns {jQuery} The jQuery element representing the scrollable area.
     */
    getScrollableArea() {
      return this.container.closest('.nicescroll-bar');
    }

    loaderData = {
      id: '', tag: {class: 'primary', tag: this.staticPH}, dateCreated: this.staticPH, imageCount: this.staticPH
    }

    prepareRow(row) {
      let data = row;

      if (!app.isEmpty(__this.globalConfig.tags)) {
        data = {...data, ...__this.globalConfig.tags};
      }

      const page = _.template(this.app.templates[this.listRow]);
      return $(page(data));
    }

    async renderList() {
      this.isRendering = true;
      this.showLoader(this.loaderData);
      let response = await this.app.apis['image-tags'].fetch();
      this.removeLoader();

      window['imageTags'] = _.indexBy(response.result, 'id');

      _.each(response.result, (row) => {
        row.tag = {'class': this.getTagClass(), tag: row.tag};
        row.actions = true;
        const $row = this.prepareRow(row)
        $row.appendTo(this.container);
      });

      this.isRendering = false;
      app.initSimpleBar(this.getScrollableArea()[0]);
      // to stop lazy loading
      return false;
    }

    refresh() {

    }

    getImages(tagId, $button) {
      const withImagesView = this.containerPlaceHolder.hasClass('tag-with-images-container') || this.containerPlaceHolder.find('.tag-with-images-container').length;
      if (!withImagesView) {
        this.containerPlaceHolder.find('.tags-container').hide();
      }
      imageInputAction(null, 'reset-image-selection');
      const imagesManager = new Images({tagId: tagId}, app, this.containerPlaceHolder, 'image_library__image-card', false);
      app.button($button, 'loading');

      imagesManager.onRenderList().then(function () {
        const $row = $(`.tag-row`);
        const $tagRow = $(`.tag-row[data-id=${tagId}]`);
        if ($tagRow.length) {
          $row.removeClass('selected');
          $tagRow.addClass('selected');
        }
        app.button($button, 'reset');
        app.initTooltip();
      })

    }

    onClick() {
      const self = this;
      const eventManager = new EventManager('image-tags', '[data-tag-action="view-images"]');
      eventManager.addEventListener('click', function () {
        let tagId = $(this).data('image-tag');
        self.getImages(tagId, $(this));
      })
    }
  }

  /**
   * Constructs an ImageCollections instance with necessary initialization.
   * @param {Object} app - The application object containing shared resources and methods.
   * @param {jQuery} containerPlaceHolder - The jQuery element to serve as the container for the image collections.
   * @param {string} listRow - The identifier for the row template to be used in list rendering.
   * @param {string} searchInputId - The ID of the search input element.
   * @param {boolean} collection - Optional. Specifies if a specific collection is to be focused initially.
   */
  class Images extends TableList {

    constructor({'collectionId': collectionId, 'tagId': tagId}, app, containerPlaceHolder, listRow, searchInputId) {
      let container;
      if (collectionId) {
        container = Images.createContainer({collectionId: collectionId}, 'image_library__collection-images', app, containerPlaceHolder);
      }
      if (tagId) {
        container = Images.createContainer({tagId: tagId}, 'image_library__tag-images', app, containerPlaceHolder);
      }

      super(app, container, listRow, searchInputId);
      this.collectionId = collectionId;
      this.tagId = tagId;
      this.isRendering = true;
      this.container = container;
      this.container.empty();
      this.renderList = this.renderList.bind(this);
      this.paginator = new Paginator(30);
      if (this.collectionId) {
        this.containerId = `collection-${collectionId}`;
        this.paginatedUrl = new PaginatedUrl(`/api/image/collection/${collectionId}`, 1, 50);
      }
      if (this.tagId) {
        this.containerId = `tag-${tagId}`;
        this.paginatedUrl = new PaginatedUrl(`/api/image/shared?byTags=${tagId}`, 1, 50);
      }

      this.container.attr('data-images', this.containerId);
      this.lazyloader = new LazyLoader(app, container, this.renderList);
    }

    /**
     * Creates and initializes the container for image collections.
     */
    static createContainer({'collectionId': collectionId, 'tagId': tagId}, template, app, containerPlaceHolder) {
      let $containerImages = containerPlaceHolder.find('[data-images]');
      if ($containerImages.length === 0) {
        const page = _.template(app.templates[template]);
        let imageTags = _.template(app.templates['image_library__image-tags']);
        imageTags = imageTags({});

        let imagesAction = _.template(app.templates['image_library__action-tag-images']);
        imagesAction = imagesAction({});

        const $container = $(page({'placeholderImageTags': imageTags, placeholderTagImagesAction: imagesAction}));
        $container.appendTo(containerPlaceHolder);

        if (collectionId) {
          const $listManager = new ImageCollections(app, $container, 'image_library__collection-card', false, {id: collectionId});
          $listManager.onRenderList().then(function () {
            const $scrollableArea = $listManager.getScrollableArea();
            const $collection = $(`.infinite-item[data-id=${collectionId}]`, $scrollableArea);
            $collection[0].scrollIntoView({behavior: 'smooth', block: 'nearest'});
          })
        }

        if (tagId) {
          const $listManager = new ImageTags(app, $container, 'image_library__row-tag', 'searchTable', {id: tagId});
          $listManager.onRenderList().then(function () {
            const $scrollableArea = $listManager.getScrollableArea();
            const $collection = $(`.tag-row[data-id=${tagId}]`, $scrollableArea);
            $collection[0].scrollIntoView({behavior: 'smooth', block: 'nearest'});
          })
        }

        $containerImages = $container.find('[data-images]');
      }

      Responsive.getImagesColumn(containerPlaceHolder, $containerImages);
      $containerImages.addClass(__this.globalConfig.imagesContainerClass);

      return $containerImages;
    }

    /**
     * Retrieves the scrollable area within the container.
     * @returns {jQuery} A jQuery object representing the scrollable area.
     */
    getScrollableArea() {
      return this.container.closest('.nicescroll-bar');
    }

    /**
     * Renders the list of image collections, loading them as needed.
     * @returns {Promise} A promise that resolves when the list has been successfully rendered.
     */
    prepareRow(row) {
      const page = _.template(this.app.templates[this.listRow]);
      row = {
        ...row,
        'checked': __this.images['selected'].includes(row.id),
        config: __this.globalConfig.images
      };

      const $page = $(page(row));

      let $images = $('[data-type="image"]', $page);
      $images.each(function (index, image) {
        if ($(image).attr('data-src') !== '') {
          app.observerManager.observeIntersection(image);
        }
      });
      return $page;
    }

    async renderList() {
      this.isRendering = true;
      const $listContainer = this.container;
      let images = [];
      this.showLoader({
        id: null,
        config: __this.globalConfig,
        checked: false,
        pathThumbnail: '',
        path: '',
        name: this.staticPH,
        images: this.staticPH,
        countText: this.staticPH
      }, 30);

      if (this.paginator.currentPage === null) {
        const response = await this.app.apis['images'].get(this.paginatedUrl.getCurrentPageUrl(true));
        this.paginatedUrl.setPageCount(response.pages);
        this.paginator.setData(response.result);
        this.paginator.setCurrentPage(1);
        images = this.paginator.getCurrentPage();
      } else {
        images = this.paginator.getNextPage();
      }

      this.removeLoader();

      _.each(images, (row) => {
        let $row = this.prepareRow(row);
        $row.appendTo($listContainer);
      });

      let hastMoreData = this.paginator.hasMoreData();
      if (hastMoreData === false) {
        hastMoreData = this.paginatedUrl.hasMoreData();
        this.paginator.setCurrentPage(null);
      }

      app.initSimpleBar(this.getScrollableArea()[0]);
      this.isRendering = false;
      return hastMoreData;
    }
  }


  /**
   * The MyUploads class extends TableList to manage and display a user's uploaded images.
   * It provides functionalities to asynchronously load, paginate, and render user uploads
   * from an API, incorporating lazy loading for efficient data handling and display.
   */
  class MyUploads extends TableList {

    /**
     * Initializes a new instance of the MyUploads class.
     * @param {Object} app - The main application object, providing access to shared resources and methods.
     * @param {jQuery} container - The jQuery element that will contain the list of uploads.
     * @param {string} listRow - The identifier for the row template used to render each upload.
     * @param {string} [searchInputId='searchTable'] - The ID of the search input element, defaults to 'searchTable'.
     */
    constructor(app, container, listRow, searchInputId = 'searchTable') {
      super(app, container, listRow, searchInputId)
      this.container = container;
      this.container.empty();
      this.renderList = this.renderList.bind(this)
      this.paginator = new Paginator(20);
      this.paginatedUrl = new PaginatedUrl(`/api/image/user`, 1, 50);
      this.lazyloader = new LazyLoader(app, container, this.renderList);
    }

    /**
     * Prepares a row for display using a specified template.
     * @param {Object} row - The data object for the row.
     * @param {string} templateName - The name of the template to use for rendering the row.
     * @returns {jQuery} A jQuery object representing the rendered row.
     * @static
     */
    static prepareRow(row, templateName) {
      const app = PreBuilt;
      let template = _.template(app.templates[templateName]);

      row = {
        config: __this.globalConfig.images,
        ...row,
      }

      const postImage = _.template(app.templates['image_library__image-card']);
      row.imageCard = postImage(row);

      const $template = $(template(row));

      let $images = $('[data-type="image"]', $template);
      $images.each(function (index, image) {
        if ($(image).attr('data-src') !== '') {
          app.observerManager.observeIntersection(image);
        }
      });
      return $template;
    }

    loaderData = {
      id: null,
      name: this.staticPH,
      dateCreated: this.staticPH,
      pathThumbnail: '',
      config: __this.globalConfig,
      path: '',
      imageCard: '',
      tags: [{'tag': this.staticPH, 'class': this.getTagClass()}, {'tag': this.staticPH, 'class': this.getTagClass()}],
    }

    /**
     * Processes loader data, optionally merging it with override data.
     * @param {Object} [overrideData={}] - Optional data to override the default loader data.
     * @returns {Object} The processed loader data merged with any override data.
     */
    processedLoaderData(overrideData = {}) {
      let data = this.loaderData;
      data.imageCard = _.template(app.templates['image_library__image-card']);
      data.imageCard = data.imageCard(data);

      data = {...data, ...overrideData};
      return data;
    }

    /**
     * Retrieves the scrollable area within the container.
     * @returns {jQuery} A jQuery object representing the scrollable area.
     */
    getScrollableArea() {
      return this.container.closest('.nicescroll-bar');
    }

    /**
     * Asynchronously renders the list of user uploads, incorporating pagination and lazy loading.
     * @returns {Promise<boolean>} A promise that resolves with a boolean indicating if there are more data to load.
     */
    async renderList() {
      let images;
      const self = this;
      const $listContainer = this.container;
      this.showLoader(this.processedLoaderData(), 30);

      if (this.paginator.currentPage === null) {
        const response = await this.app.apis['uploads'].list(this.paginatedUrl.getCurrentPageUrl(true));
        this.paginatedUrl.setPageCount(response.pages);
        this.paginator.setData(response.result);
        this.paginator.setCurrentPage(1);
        images = this.paginator.getCurrentPage();
      } else {
        images = this.paginator.getNextPage();
      }

      this.removeLoader();

      _.each(images, (row) => {
        // Add classes to tags
        row.tags = row.tags.map(tag => {
          tag.class = self.getTagClass();
          return tag;
        })

        let $row = MyUploads.prepareRow(row, self.listRow);
        $row.appendTo($listContainer);
      });

      let hasMoreData = this.paginator.hasMoreData();

      if (hasMoreData === false) {
        hasMoreData = this.paginatedUrl.hasMoreData();
        this.paginator.setCurrentPage(null);
      }

      app.initSimpleBar(this.getScrollableArea()[0]);

      return hasMoreData;
    }
  }

  window["MyUploads"] = MyUploads;

  aimi_image_library.tagsSaveCallback = function (response) {
    // Display a notification with the response message and set the progress to 90%
    app.notifyEl.update({'message': response.message, progress: 90});

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);
    const payload = response.payload;

    aimi_image_library.tags.refresh();
  };


  aimi_image_library.imageTagsSaveCallback = function (response) {
    // Display a notification with the response message and set the progress to 90%
    app.notifyEl.update({'message': response.message, progress: 90});

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);
    const payload = response.payload;

    if (__this.activeTab === '#image_lib_tab_block_3') {
      __this.refreshMyUploads();
    }
    if (__this.activeTab === '#image_lib_tab_block_2') {
      const $row = $('tr.tag-row.selected');
      const tagId = $row.data('id');
      aimi_image_library.tags.refresh(null, tagId);
      const imagesManager = new Images({tagId: tagId}, app, $('.tag-with-images-container'), 'image_library__image-card', false);

    }
  };

  function imageInputAction(e, action = null) {
    const $tagImagesActionContainer = $('.tag-images-action-wrapper');
    const $imagesCountContainer = $('[data-images-selected]', $tagImagesActionContainer);
    const $this = $(this);
    action = action || $this.data('image-input-action');

    if (action === 'image-selection') {
      const $item = $(e.target).closest('.infinite-item');
      let imageId = $item.data('id');

      if ($this.is(":checked")) {
        __this.images.selected.push(imageId);
      } else {
        __this.images.selected = __this.images.selected.filter(id => id !== imageId);
      }

      __this.images.selected = [...new Set( __this.images.selected)];

      if (__this.images.selected.length) {
        const imageText = __this.images.selected.length === 1 ? 'image' : 'images';
        $imagesCountContainer.html(`<span class=" badge badge-pill badge-info fw-semibold fs-8 p-1">${__this.images.selected.length}</span> ${imageText} selected`);
        $tagImagesActionContainer.addClass('show');
      } else {
        $imagesCountContainer.text(``);
        $tagImagesActionContainer.removeClass('show');
      }
    }
    if (action === 'reset-image-selection') {
      __this.images.selected = [];
      $imagesCountContainer.text(``);
      $tagImagesActionContainer.removeClass('show');
    }
  }

  function imageAction(e) {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(this);
    const action = $this.data('image-action');
    let $item = $(e.target).closest('.infinite-item');
    let imageId = $item.data('id');

    if (action === 'tag' || action === 'tag-multiple') {
      if (action === 'tag-multiple' && __this.images.selected.length === 0) {
        const $modal = app.infoModal(`Tag Images`, 'Please select any image to tag, to select an image click any where on image ', {});
        return false;
      }

      app.inputPrompt({
        type: 'input',
        modalDialogClass: 'modal-lg',
        template: 'image_library__tags-prompt',
        title: 'Tag Images',
        saveButtonText: 'Save',
        footerText: '<span class="fw-semibold"><span class="text-primary"> Note: </span> To create a new tag, type into the field and press return key</span>',
        saveApi: 'image-tags.tagMultiple',
        saveApiCallBack: 'aimi_image_library.imageTagsSaveCallback'
      }).then(function (modal) {
        if (action === 'tag') {
          $('input[name="ids[]"]', modal).val(imageId);
        } else {
          $('input[name="ids[]"]', modal).val(__this.images.selected);
        }

        app.apis['user-tags'].fetch().done(function (response) {
          const $addTags = $('select[name="addTags[]"]', modal);
          const $removeTags = $('select[name="removeTags[]"]', modal);

          let $options = response.result.map(option => `<option value="${option.tag}">${option.tag}</option>`).join('');
          $addTags.html($options);

          $options = response.result.map(option => `<option value="${option.id}">${option.tag}</option>`).join('');
          $removeTags.html($options);

          $('select', modal).each(function () {
            const $select = $(this);
            $select.attr('multiple', 'multiple');
            $('.m-progress', modal).removeClass('m-progress');
            $select.val([]).trigger('change');
          });

          $removeTags.select2({
            dropdownCssClass: 'tags-select2-dropdown',
            selectionCssClass: 'tags-select2-selection',
            tags: true,
            tokenSeparators: [',', ' '],
            createTag: function (params, e) {
              const term = $.trim(params.term);

              // Check if the term is already in the predefined list
              if (term === '' || $removeTags.find('option').filter(function () {
                return $.trim($(this).text()) === term;
              }).length === 0) {
                return null; // Do not create a new tag
              }

              // Return the tag for creation
              return {
                id: term, text: term, newTag: true // Add a new tag indicator
              };
            }
          });

          $addTags.select2({
            dropdownCssClass: 'tags-select2-dropdown',
            selectionCssClass: 'tags-select2-selection',
            tags: true,
            tokenSeparators: [',', ' ']
          });
        })
      });

    }

    if (action === 'delete') {
      let id = $(this).data('id');
      app.confirm("Delete Image?", "Are you sure you want to delete this image? Deleting an image will remove it from your library").then(function (response) {
        const $button = response.button;
        const confirm = response.confirm;
        const $modal = response.modal;

        // If the user confirms the deletion, proceed with the delete operation.
        if (confirm === true) {
          app.doButtonAction($button);
          app.apis['uploads'].delete(id).done(function (response) {
            if (response.success !== true) {

            } else {
              // Render list if deleted
              __this.refreshMyUploads();
            }
            app.doButtonReset($button, true, 100);
            app.hideModal($modal);
          }).fail(function (response) {
            app.doButtonReset($button, false);
            app.hideModal($modal);
          });
        }
      });
    }

    if (action === 'add-to-campaign') {
      const $input = $item.find('input');
      $input.prop('checked', !$input.is(":checked"));
    }


    if (action === 'add-tag-to-campaign') {
      $item = $this.closest('.tag-row');
      $item.toggleClass('selected');
    }
  }

  aimi_image_library.init = function (containerSelector, containerRoot, config = {}) {
    __this.containerSelector = containerSelector;
    __this.containerRoot = containerRoot;

    __this.$container = $(containerSelector);
    __this.globalConfig = {...__this.defaultConfig, ...config};

    const $container = $(containerSelector);


    let page = _.template(app.templates['image_library__tab-image-collections']);
    $(page()).appendTo($container);

    page = _.template(app.templates['image_library__tab-image-tags']);
    $(page()).appendTo($container);

    page = _.template(app.templates['image_library__tab-uploads']);
    $(page()).appendTo($container);

    page = _.template(app.templates['image_library__tab-uploader']);
    $(page()).appendTo($container);

    aimi_image_library.collections.init();
    aimi_image_library.tags.init();

    if (!app.isEmpty(__this.globalConfig.menus)) {
      page = _.template(app.templates['image_library__menus']);
      $('.header-tabs-start', $(containerRoot)).replaceWith($(page(
          {menus: __this.globalConfig.menus, activeMenuIndex: __this.globalConfig.activeMenuIndex}
      )));

      const triggerTabList = [].slice.call($(containerRoot).find('a.nav-link'));

      triggerTabList.forEach(function (triggerEl) {
        let tabTrigger = new bootstrap.Tab(triggerEl)
      })
    }

    aimi_image_library.navigate(`#image_lib_tab_block_${__this.globalConfig.activeMenuIndex}`);
  }

  aimi_image_library.navigate = function (activeTab) {
    __this.$acitveTabContent = $(`${activeTab}`);
    Utils.showTabContent(__this.$acitveTabContent);

    if (activeTab === '#image_lib_tab_block_1') {
      aimi_image_library.collections.refresh();
    }

    if (activeTab === '#image_lib_tab_block_2') {
      aimi_image_library.tags.refresh(true);
    }

    if (activeTab === '#image_lib_tab_block_3') {
      MassActions.destroy();
      __this.refreshMyUploads();
    }
  }

  aimi_image_library.tags = {

    init: function () {
      const self = this;
      const $tab = $('[data-tab="image-tags"]');
      const $container = $('[data-image-tags]');
      const tagsEventManager = new EventManager('image-library', '[data-tag-action]');

      function tagAction(e) {
        e.preventDefault();
        e.stopPropagation();

        const $this = $(this);
        const action = $this.data('tag-action');
        const $item = $(e.target).closest('tr.tag-row');
        let tagId = $item.data('id');

        if (action === 'new-tag') {
          app.inputPrompt({
            type: 'input',
            value: '',
            title: 'New Tag',
            saveButtonText: 'Save Tag',
            inputLabel: '<span class="text-center">Enter one or more tags, separating each with a comma.</span>',
            inputName: 'tag',
            placeHolder: 'i.e. Tag1, Tag2',
            saveApi: 'user-tags.saveMultiple',
            saveApiCallBack: 'aimi_image_library.tagsSaveCallback'
          }).then(function (response) {

          });
        }

        if (action === 'edit') {
          app.inputPrompt({
            id: tagId,
            type: 'input',
            value: $item.data('tag'),
            title: 'Edit Tag',
            saveButtonText: 'Update Tag',
            inputLabel: '<span class="text-center">Enter the new tag you wish to use as a replacement for your current tag.</span>',
            inputName: 'tag',
            placeHolder: 'i.e. Tag1, Tag2',
            saveApi: 'user-tags.update',
            saveApiCallBack: 'aimi_image_library.tagsSaveCallback'
          }).then(function (response) {

          });
        }

        if (action === 'delete') {
          let id = $(this).data('id');
          app.confirm("Delete Tag?", "Are you sure you want to delete this tag? Deleting an tag will remove it from your library").then(function (response) {
            const $button = response.button;
            const confirm = response.confirm;
            const $modal = response.modal;

            // If the user confirms the deletion, proceed with the delete operation.
            if (confirm === true) {
              app.doButtonAction($button);
              app.apis['user-tags'].delete(id).done(function (response) {
                if (response.success !== true) {

                } else {
                  const $imagesContainer = $(`[data-images="tag-${id}"]`);
                  if ($imagesContainer.length) {
                    $imagesContainer.empty();
                    const noRecordsOptions = {
                      class: 'no-images-for-tags',
                      title: 'Tag Deleted ',
                      description: `Please select any other tag to view images`,
                      addButton: null,
                      help: {
                        text: 'Need Help ?',
                        onClick: () => {
                          console.log('Help clicked');
                        }
                      },
                    };

                    this.placeholder = new NoRecordsPlaceholder(app, $imagesContainer, noRecordsOptions);
                    this.placeholder.render();
                  }
                  // Render list if deleted
                  aimi_image_library.tags.refresh(false, id);
                }
                app.doButtonReset($button, true, 100);
                app.hideModal($modal);
              }).fail(function (response) {
                app.doButtonReset($button, false);
                app.hideModal($modal);
              });
            }
          });
        }

      }

      tagsEventManager.addEventListener('click', tagAction);
    },

    refresh: function (hardRefresh = false, tagId = null) {
      const $container = $('.image-tags-container');

      if (hardRefresh) {
        $container.empty();
      }

      __this.imageTagsManager = new ImageTags(app, $container, 'image_library__row-tag', 'searchTable');
      if (tagId) {
        __this.imageTagsManager.onRenderList().then(function (response) {
          const $tagRow = $(`tr.tag-row[data-id=${tagId}]`);

          if ($tagRow.length) {
            $tagRow.addClass('selected');

            if ($tagRow.data('imagesCount') === 0) {
              imageInputAction(null, 'reset-image-selection');
              const $imagesContainer = $(`[data-images="tag-${tagId}"]`);
              if ($imagesContainer.length) {
                $imagesContainer.empty();
                const noRecordsOptions = {
                  class: 'no-images-for-tags',
                  title: 'No images for selected tag',
                  description: `Please select any other tag to view images`,
                  addButton: null,
                  help: {
                    text: 'Need Help ?',
                    onClick: () => {
                      console.log('Help clicked');
                    }
                  },
                };

                this.placeholder = new NoRecordsPlaceholder(app, $imagesContainer, noRecordsOptions);
                this.placeholder.render();
              }
            } else {

            }
          }

        })
      }
    },
  }

  aimi_image_library.collections = {
    /**
     * Initializes the image collections.
     *
     * This function initializes the image collections, sets up event listeners for tab clicks,
     * and refreshes the collections when necessary.
     *
     * @memberof aimi_image_library.collections
     * @function init
     */
    init: function () {
      const $container = $(__this.containerSelector);
      const $tabUploads = $container.find('[data-tab="my-uploads"]');
      const $myUploadsContainer = $container.find('[data-my-uploads]');

      // My Uploads
      app.observerManager = new ImageObserverManager(app, null, false);
      __this.$myUpladsManager = new MyUploads(app, $myUploadsContainer, 'image_library__row-upload', 'searchTable');

      // My uploads
      __this.refreshMyUploads = function () {
        __this.$myUpladsManager = new MyUploads(app, $myUploadsContainer, 'image_library__row-upload', 'searchTable');
      }

      // Uploader
      __this.$uploader = new Uploader(app, $('[data-uploader]'), {
        'namespace': 'multiple-uploader', title: false, button: false
      }, __this.refreshMyUploads);

      __this.$uploader.dropify();

      $tabUploads.off('change.aimi_uploads_click').on('change.aimi_uploads_click', 'tr.infinite-item input[type="checkbox"]', function (e) {

        // Collects all checked hashtags.
        const ids = $(`tr.infinite-item input[type="checkbox"]:checked`).map(function () {
          return this.value;
        }).get();

        MassActions.destroy();

        // Check if any hashtags were selected for deletion.
        if (ids.length === 0) {

        } else {
          const massOptions = {
            separator: false,
            title: 'Mass Action',
            description: '',
            deleteButton: {
              text: 'Delete Selected',
              onClick: (e) => {
                const deleteImage = async function (imageId) {
                  return await app.apis['uploads'].delete(imageId);
                }
                app.confirm("Delete Image?", "Are you sure you want to delete selected images? Deleting an image will remove it from your library").then(async function (response) {
                  const $button = response.button;
                  const confirm = response.confirm;
                  const $modal = response.modal;

                  // If the user confirms the deletion, proceed with the delete operation.
                  if (confirm === true) {
                    app.doButtonAction($button);
                    try {
                      let results = [];
                      const batchPromises = __this.images.selected.map(id => deleteImage(id));
                      results = results.concat(await Promise.all(batchPromises));
                    } catch (e) {
                      console.log(e);
                    }
                    app.hideModal($modal);
                    app.doButtonReset($button, true, 100);
                    __this.refreshMyUploads();
                  }
                });
              }
            },
            tagButton: {
              text: 'Tag Selected',
              onClick: (e) => {
                let $button = $(e.currentTarget);
                $button.attr('data-image-action', 'tag-multiple');
              }
            }
          };

          console.log($('[data-mass-actions]'), $tabUploads );

          const massActions = new MassActions(app, $('[data-mass-actions]', $tabUploads), massOptions);
          massActions.render();
        }
      });

      // Events
      const tabEventManager = new EventManager('image-library', `${__this.containerRoot} .hk-pg-header a[data-bs-toggle='tab']`);
      const imageActionEventManager = new EventManager('image-library', `[data-image-action]`);
      const imageInputActionEventManager = new EventManager('image-library', `${__this.containerRoot} [data-image-input-action]`);
      const uploaderEventManager = new EventManager('image-library', `${__this.containerRoot} [data-uploader-action="expand"]`);

      // Upload new button
      let uploadsDrawer = '.hk-drawer.uploads-drawer';
      $tabUploads.off('click.upload-new').on("click.upload-new", ".btn-add-new", function (e) {
        const $drawer = $(uploadsDrawer);
        $drawer.css({"border": "none", "box-shadow": "0 8px 10px rgba(0, 0, 0, 0.1)"}).toggleClass('drawer-toggle');
        __this.$uploader.clearPreview();
        return false;
      });

      // Add new tag Button
      $tabUploads.off('click.upload-new').on("click.upload-new", ".btn-add-new", function (e) {
        const $drawer = $(uploadsDrawer);
        $drawer.css({"border": "none", "box-shadow": "0 8px 10px rgba(0, 0, 0, 0.1)"}).toggleClass('drawer-toggle');
        __this.$uploader.clearPreview();
        return false;
      });

      // When an image is selected, input type checkbox change event
      imageInputActionEventManager.addEventListener('change', imageInputAction);

      imageActionEventManager.addEventListener('click', imageAction);
      uploaderEventManager.addEventListener('click', function () {
        const $drawer = $(uploadsDrawer);
        $drawer.toggleClass('uploads-drawer-extended');
      });


      tabEventManager.addEventListener('click', function () {
        const $activeNav = $(this);
        __this.activeTab = $activeNav.attr('href');
        aimi_image_library.navigate($activeNav.attr('href'));
      });

      __this.tabEventManager = tabEventManager;

    },

    /**
     * Refreshes the image collections.
     *
     * @param {jQuery} $container - The jQuery element representing the container for image collections.
     * @memberof aimi_image_library.collections
     * @function refresh
     */
    refresh: function () {
      const $container = __this.$container.find('.image-collections-container');
      $container.empty();

      const $listManager = new ImageCollections(app, $container, 'image_library__collection-card', false);

      $listManager.onRenderList().then(function () {
        const $imageCollectionsSelect = $(':input[name="imageCollections"]');

        if (!$imageCollectionsSelect.data('loaded')) {

          $imageCollectionsSelect.data('loaded', true);

          const $options = __this.collections.list.map(option => `<option value="${option.name}" data-count="${option.images}" data-thumbnail="${option.thumbnail}">${option.name}</option>`).join('');
          const $defaultOption = `<option value=""></option>`
          $imageCollectionsSelect.html($defaultOption + $options);
          __this.fontFormatState = function (state) {
            if (!state.id) {
              return state.text;
            }
            const count = $(state.element).data('count');
            const thumbnail = $(state.element).data('thumbnail');
            const $this = $(`<span class=" fs-7 fw-semibold"><img style="background-image: url(${thumbnail}); background-size: contain" class="img-thumbnail mh-100p w-70p h-70p me-2" /> ${state.text} <span class="badge badge-soft-dark badge-images-count float-end mt-3 "> ${count}</span> </span>`);
            return $this;
          };

          $('.image-collections-select-wrapper').find('.m-progress').removeClass('m-progress');

          $imageCollectionsSelect.select2({
            placeholder: 'Search Image Collections...',
            allowClear: true, // Allow clearing the selection
            dropdownCssClass: 'image-collections-select2-dropdown',
            selectionCssClass: 'font-select2-selection',
            dropdownParent: $container,
            theme: 'bootstrap-5',
            templateResult: __this.fontFormatState
          });

          const searchCollection = (searchTerm) => {

            const filteredItems = __this.collections.list.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()));

            // Find the item with the minimum id
            const minId = filteredItems.reduce((minItem, item) => !minItem || item.id < minItem.id ? item : minItem, null);

            $(`.infinite-item`, $container).removeClass('d-block');
            const $row = $(`.infinite-item`, $container).eq(0).closest('.row');
            if (!app.isEmpty(filteredItems)) {
              $row.addClass('search-mode');
              $listManager.loadTillCollection(minId).then(function () {

                $listManager.onRenderList().then(function () {
                  filteredItems.forEach(function (collection) {
                    $(`.infinite-item[data-id="${collection.id}"]`, $container).addClass('d-block');
                  });
                })

              });
            } else {
              $row.removeClass('search-mode');
            }
          }

          $imageCollectionsSelect.on('select2:open', () => {
            $('.select2-search__field').attr('placeholder', 'Start typing to see results')
                .on('input', function (e) {
                  const searchTerm = this.value.toLowerCase();
                  searchCollection(searchTerm);
                });
          });

          $imageCollectionsSelect.on('change', (e) => {
            const searchTerm = $(e.currentTarget).val();
            searchCollection(searchTerm);
          });

        }

      })
    }
  }

}(window.aimi_image_library = window.aimi_image_library || {}, jQuery, PreBuilt));
